export default {
  creator_profile_image: "object",
}
